module.exports = (__webpack_require__("xDzS"))(2);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/process/browser.js from dll-reference common_library
// module id = W2nU
// module chunks = 16 17 18 19